import React, { useState} from "react";

function AddLessonButton({clickHandler}) {
    return <>
        <button className="todo-button" onClick={(e) => clickHandler(e)}>
            <i className="fas fa-plus"></i>
        </button>
    </>
}

export default AddLessonButton